import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import {
  columnCode,
  columnCreatedOn,
  columnDescription,
  columnMultiSelect,
  columnNameLink,
  columnPublisher,
  columnCollections,
  columnTools,
  columnUpdatedOn,
  columnVisibility,
} from '@/constants/fields';
import { states } from '@/constants/lifecycle';
import urls, { codeUrl } from '@/constants/urls';
import { fitToPage, goToCategoryPage } from '@/hooks/paging';
import TableWrapper from '@/components/table/TableWrapper';
import NoRowsWithPagination from '@/components/table/NoRowsWithPagination';
import DatasetsTableRows from './DatasetsTableRows';
import DatasetsTableHeader from './DatasetsTableHeader';
import DatasetsFilters from '../containers/DatasetsFilters';
import DatasetsTableSettingsMenu from '../containers/DatasetsTableSettingsMenu';
import DatasetsDataModelFilter from '../datamodels/components/DatasetsDataModelFilter';

const DatasetsTable = ({
  allowDataModelRead,
  canCreate,
  category,
  className,
  columns = [
    columnMultiSelect,
    columnNameLink,
    columnCode,
    columnDescription,
    columnCreatedOn,
    columnUpdatedOn,
    columnVisibility,
    columnPublisher,
    columnCollections,
    columnTools,
  ],
  currentPage,
  datasets,
  fetchData,
  hideColumns,
  newDatasetCode,
  onCheckBoxClick,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  theme,
  total,
}) => {
  const { items, pageNumber } = fitToPage(datasets, currentPage, pageSize);
  const ref = React.useRef(null);

  return (
    <div className={clsx('ReactTable', className)} ref={ref}>
      <TableWrapper sticky celled className="aridhia-datasets-table" columns={columns}>
        <DatasetsTableHeader
          category={category}
          columns={columns}
          datasets={items}
          hideColumns={hideColumns}
          loaderButton={!hideColumns}
          readErrors={readErrors}
          readStatus={readStatus}
        >
          { readStatus === states.SUCCESS && !hideColumns && <DatasetsTableSettingsMenu category={category} />}
          { allowDataModelRead && <DatasetsDataModelFilter category={category} /> }
          <DatasetsFilters category={category} className="aridhia-table-filter ml-10" />
        </DatasetsTableHeader>
        <Table.Body>
          <DatasetsTableRows
            items={items}
            columns={columns}
            onCheckBoxClick={(value) => onCheckBoxClick(category, value)}
            theme={theme}
          />
        </Table.Body>
      </TableWrapper>
      <NoRowsWithPagination
        canCreate={canCreate}
        currentPage={pageNumber}
        entity="dataset"
        goToPage={({ page }) => goToCategoryPage(fetchData, category, page, ref)}
        icon="table"
        items={items}
        pageCount={pageCount}
        readErrors={readErrors}
        readStatus={readStatus}
        total={total}
        url={codeUrl(urls.DATASET, newDatasetCode, '#')}
      />
    </div>
  );
};

export default DatasetsTable;
